module.exports = __webpack_public_path__ + "img/wirecard.56b806c8.png";